export const getPageIdFromPathname = (pathname: string): string =>
  pathname.replace(/[^A-Za-z1-9|_^-]/g, '')
